import React, { useState, useEffect, useRef } from "react";
import { Dropdown, Space } from "antd";
import { Link, Route } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { SidebarData } from "../Dashboard/SidebarData";
import { Noti } from "../../../assets/images";
import { IconContext } from "react-icons";
import "./Dashboard.css";

import * as api from "../../../api/index";

import DashBoardTable from "./DashBoardTable";
// import Chat from "../Chat/Chat";
import Account from "../Account/Account";
import Consutations from "../Dashboard/Consutations";
import AllConsultaions from "./AllConsultaions";
import ViewConsutations from "../ViewConsutation/ViewConsutations";
import { useSelector } from "react-redux";
import { imageURL } from "../../../api/index";
import MessagingPage from "../Messages/Messages";
import Notification from "../Notifications/Notification";

function DashboardNavbar() {
  const [sidebar, setsidebar] = useState(false);
  const showsidebar = () => setsidebar(!sidebar);
  const { user } = useSelector((state) => state.auth);
  const [showDropDown, setShowDropDown] = useState(false);

  const options = ["one", "two", "three"];
  const ref = useRef();

  useEffect(() => {
    document.addEventListener("click", handleClickOutSide, true);
    return () => {
      document.removeEventListener("click", handleClickOutSide, true);
    };
  }, [ref]);

  const handleClickOutSide = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setsidebar(false);
    }
  };

  const LogOut = async () => {
    const result = await api.logoutApi();
    if (result?.status === 200) {
      localStorage.removeItem("token");
      localStorage.removeItem("auth");
      window.location.pathname = "/";
    }
  };

  const items = [
    {
      label: (
        <button className="signin-dropdown" onClick={LogOut}>
          Logout
        </button>
      ),
      key: "0",
    },
  ];
  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <div className="dashnav">
          <Link to="#" className="menu-bars">
            <FaIcons.FaBars onClick={showsidebar} />
          </Link>

          <div className="pro_details">
            <div className="dash_btn">
              <Link to="/">
                <button className="btndash1">Go to Website</button>
              </Link>
              <div
                style={{
                  cursor: "pointer",
                }}
              >
                <Link to="/dashboard/notifications">
                  <Noti />
                </Link>
              </div>
              <div className="btndash2"></div>
              <button
                class="profile-navbar "
                onClick={() => setShowDropDown(!showDropDown)}
              >
                <div className="flex align-items-center">
                  <img
                    src={
                      user?.patient?.profilePicture
                        ? `${imageURL}/${user?.patient?.profilePicture}`
                        : "/img/man.png"
                    }
                    className="h-[30px] w-[30px] object-cover rounded-full"
                    alt=""
                  />
                  <div className="flex content-center ml-[5px]">
                    <span>
                      {`${user?.patient?.firstName} ${user?.patient?.lastName}`}
                    </span>
                  </div>
                </div>
              </button>
            </div>
          </div>
          {showDropDown && (
            <div class="dropdown-content-navbar">
              <Link to="/dashboard">
                <button className="dashboard-link">Dashboard</button>
              </Link>
              <button className="signin-dropdown" onClick={LogOut}>
                Logout
              </button>
            </div>
          )}
        </div>

        <Route path="/dashboard/" exact component={DashBoardTable} />
        <Route path="/dashboard/messages" component={MessagingPage} />
        <Route path="/dashboard/Account" component={Account} />
        <Route path="/dashboard/notifications" component={Notification} />
        <Route path="/dashboard/consutations" component={Consutations} />
        <Route path="/dashboard/allconsultations" component={AllConsultaions} />
        <Route
          path="/dashboard/ViewConsutations/:id"
          component={ViewConsutations}
        />

        <nav className={sidebar ? "nav-menu active" : "nav-menu"} ref={ref}>
          <div className="dashlogo">
            <Link to="/">
              <img src="/img/logo.png" />
            </Link>
          </div>
          <div className="navbar-toggle ">
            <div onClick={showsidebar} className="menu-bars forMarginTop">
              <AiIcons.AiOutlineClose color="#000" />
            </div>
          </div>

          <div className="contact_ddiv flex flex-col justify-content-center py-[20px]">
            {/* <IoIosContact style={{ height: "130px", width: "16rem" }} /> */}
            <img
              src={
                user?.patient?.profilePicture
                  ? `${imageURL}/${user?.patient?.profilePicture}`
                  : "/img/man.png"
              }
              style={{
                borderRadius: "50%",
                height: "120px",
                width: "120px",
                alignSelf: "center",
                display: "block",
                objectFit: "cover",
                // position: "absolute",
                // marginLeft: "70px",
                // paddingTop: "40px",
              }}
            />
            <h4 className="con_name">
              {user && `${user?.patient?.firstName} ${user?.patient?.lastName}`}
            </h4>
          </div>

          <ul className="nav-menu-item ">
            {SidebarData.map((item, index) => {
              return <SideBarItem item={item} index={index} />;
            })}
          </ul>
        </nav>
      </IconContext.Provider>
    </>
  );
}

export default DashboardNavbar;

const SideBarItem = ({ item, index }) => {
  const [active, setactive] = useState(false);
  return (
    <li key={index} className={item.cName}>
      {item.dropDownOption ? (
        <>
          <div
            onClick={() => {
              setactive((prev) => !prev);
            }}
          >
            {item.icon}
            <span className="map_span">{item.title}</span>
          </div>

          {active &&
            item.dropDownOption.map((item) => {
              return (
                <div className="dd-link">
                  <Link to={item.path}>
                    {" "}
                    <div
                      id="jjj"
                      className={item.cName}
                      style={{ marginTop: "25px" }}
                    >
                      {" "}
                      {item.name}{" "}
                    </div>
                  </Link>
                </div>
              );
            })}
        </>
      ) : (
        <Link to={item.path}>
          <span className="map_span">{item.title}</span>
        </Link>
      )}
    </li>
  );
};
